//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchCam from '~/mixins/searchCam.js';

export default {
  name: 'searchFilterCam',
  mixins: [searchCam],
};
